<template>
	<Layout :pageTitle="'Eventos'">
		<template #cta>
			<router-link tag="a" to="/events/create" class="btn btn-primary">Crear evento</router-link>
		</template>

		<template #bar>
			<div class="filters-box justify-content-between">
				<div class="filter">
					<div class="filter-input">
						<i class="icon icon-search"></i>
						<input
							type="text"
							class="form-control"
							placeholder="Buscar en eventos"
							v-model="filters.search"
							@keyup.enter="updateFilters($event)"
						/>
						<div
							class="btn btn-light btn-clear-filter"
							v-if="filters.search"
							@click="
								filters.search = null
								updateFilters()
							"
						>
							<i class="icon icon-close"></i>
						</div>
					</div>
				</div>
			</div>
		</template>

		<template #head>
			<div>
				<ul class="nav nav-tabs border-none">
					<li class="nav-item">
						<router-link
							tag="a"
							:to="`/events?status=next`"
							:class="{ active: !filters.status || filters.status == 'next' }"
							class="nav-link"
							>Próximos</router-link
						>
					</li>
					<li class="nav-item">
						<router-link
							tag="a"
							:to="`/events?status=past`"
							:class="{ active: filters.status == 'past' }"
							class="nav-link"
							>Pasados</router-link
						>
					</li>
				</ul>
			</div>
		</template>

		<Loader :show="loading" type="inline" />

		<div class="main-container container p-3" v-if="!loading">
			<router-link
				tag="div"
				:to="`${$route.path}/${item.id}`"
				v-for="item of list"
				:key="item.id"
				class="card mb-3"
			>
				<div class="card-body">
					<div class="event-item">
						<div
							class="image"
							v-if="item && item.image"
							:style="`background-image: url(${item.image.url})`"
						></div>
						<div class="data">
							<span class="d-flex">
								<i class="dot mt-1 mr-1" :class="`dot-${item.statusClass}`"></i>
								<span>{{ item.statusText }}</span>

								<span v-if="item.status == 'ACTIVE' && item.isProgrammed" class="ml-1">
									para el día {{ item.publicFrom | moment("ddd DD MMM HH:mm") }}
								</span>
							</span>
							<h2>{{ item.name }}</h2>
							<p class="text-secondary" v-if="item.location">
								{{ item.startAt | moment("ddd DD MMM YYYY HH:mm") }} • {{ item.location.name }},
								{{ item.location.locality.name }}
							</p>
							<div class="d-flex">Código de evento: #{{ item.code }}</div>
						</div>
						<div class="stats">
							<b-progress :max="item.ticketsLimit" height="6px">
								<b-progress-bar :value="item.ticketsSold" variant="success"></b-progress-bar>
							</b-progress>
							<div class="d-flex justify-content-between">
								<div>
									<h5>{{ item.ticketsSold }} vendidas</h5>
									<span class="text-secondary">de {{ item.ticketsLimit }}</span>
								</div>
								<div class="text-right">
									<h5>{{ item.currencySymbol }} {{ item.totalSales | toCurrency }}</h5>
									<span class="text-secondary">ventas netas</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</router-link>

			<div class="card" v-if="!loading && list.length == 0">
				<div class="card-body text-center py-4">
					<h5>
						<span v-if="filters.status == 'past'">No tienes eventos pasados</span>
						<span v-else>Aún no tienes eventos</span>
					</h5>
					<p>Crea tu próximo evento</p>
					<router-link tag="a" to="/events/create" class="btn btn-primary mt-2">Crear evento</router-link>
				</div>
			</div>

			<div class="mt-3">
				<Pagination :pageData="pagination" @pageChange="pageChange" />
			</div>
		</div>
	</Layout>
</template>

<script>
import gql from "graphql-tag"

export default {
	name: "Events",
	data() {
		return {
			list: [],
			loading: true
		}
	},
	beforeMount() {
		this.filters = this.getValidUrlParams()
		this.load()
	},
	methods: {
		load() {
			this.loading = true
			this.$apollo
				.query({
					query: gql`
						query($take: Int, $skip: Int, $status: String, $search: String) {
							events(take: $take, skip: $skip, status: $status, search: $search) {
								data {
									id
									code
									name

									startAt
									ticketsSold
									ticketsLimit
									totalSales
									currencySymbol
									image {
										id
										url
									}
									location {
										id
										name
										address
										locality {
											id
											name
										}
									}
									isProgrammed
									publicFrom
									status
									statusText
									statusClass
								}
								pageInfo {
									totalItems
								}
							}
						}
					`,
					variables: {
						take: this.pagination.length,
						skip: this.pagination.skip,
						status: this.filters.status ? this.filters.status : "next",
						search: this.filters.search
					},
					fetchPolicy: "network-only"
				})
				.then(({ data }) => {
					this.list = data.events.data
					this.pagination.pageInfo = data.events.pageInfo
					this.loading = false
				})
				.catch(() => {
					this.loading = false
				})
		}
	}
}
</script>

<style scoped lang="scss">
.event-item {
	display: flex;
	align-items: center;
	padding: 10px;
	cursor: pointer;

	.image {
		width: 82px;
		height: 82px;
		border-radius: 4px;
		background-color: #eee;
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
	}

	.data {
		flex: 1;
		padding-left: 12px;

		h2 {
			margin-bottom: 0px;
			font-weight: 700;
			font-size: 18px;
			line-height: 24px;
		}
		p {
			padding: 0px;
			margin: 0px;
		}
	}
	.stats {
		flex-grow: 1;
		max-width: 300px;

		h5 {
			font-size: 15px;
			margin-top: 10px;
			line-height: 12px;
		}
	}
}
</style>
